export default __webpack_public_path__ + "assets/media/upload-finished-left.d2242508.png";